module.exports = __webpack_public_path__ + "c2595e848616c146ac648be9ecaa44b4.jpg";